export default "__VITE_ASSET__B_Gb4PRD__"